<div class="left-modal">
  <div class="close" (click)="close()"></div>
  @if (!loading) {
    <div class="modal-container">
      <h1>{{'Add comment' | translate}}</h1>
      <form #form="ngForm" (ngSubmit)="submitForm()" novalidate>
        <div class="L-12 M-12 S-12 columns">
          <label>{{'Comment' | translate}}**</label>
          <textarea rows="5" name="comment" [(ngModel)]="comment.comment" placeholder="{{'Insert text' | translate}}" ></textarea>
          <!-- <input class="centered" type="time" name="time" [(ngModel)]="data.time" required> -->
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <input name="sumbit" type="submit" value="{{'Save' | translate}}"  [attr.disabled]="form.invalid?'':null">
        </div>
        <div class="L-12 M-12 S-12 columns TextCentered">
          <a class="button cancel" (click)="close()">{{'Cancel' | translate}}</a>
        </div>
      </form>
    </div>
  }
</div>